import { Component, type ReactNode } from 'react'
import { Box, Button, Typography, Stack } from '@mui/material'

interface Props {
  children: ReactNode
}
interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null }
  static getDerivedStateFromError(error: Error): State {
    return { error }
  }
  override componentDidCatch(error: Error, info: unknown) {
    console.error('[ErrorBoundary]', error, info)
  }
  reset = () => this.setState({ error: null })
  override render() {
    if (this.state.error) {
      return (
        <Box sx={{ p: 4 }}>
          <Stack spacing={2} maxWidth={600}>
            <Typography variant="h5">Something went wrong</Typography>
            <Typography variant="body2" color="text.secondary">
              {this.state.error.message}
            </Typography>
            <Box>
              <Button variant="contained" onClick={this.reset}>
                Reset
              </Button>
            </Box>
          </Stack>
        </Box>
      )
    }
    return this.props.children
  }
}
